import { render } from "./BulletinEdit.vue?vue&type=template&id=2f4779b9"
import script from "./BulletinEdit.vue?vue&type=script&lang=js"
export * from "./BulletinEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-management\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__